module.exports = __webpack_public_path__ + "img/harsh-braking.704f5f2a.svg";